import { Box, Modal, Typography } from "@mui/material";
import "./style.css";
import React from "react";
import { useSelector } from "react-redux";
import PerformanceChart from "../commonComponents/PerformanceChart";
import PerformanceCard from "../commonComponents/PerformanceCard";
import { useNavigate } from "react-router";
import CelebrationAnimation from "../CelebrationAnimation";
import { formatedTime } from "../../utils/globalFunction";
import styled from "styled-components";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  bgcolor: "var(--background-color)",
  color: "var(--color)",
  border: "0.1rem solid var(--color)",
  boxShadow: 24,
  borderRadius: "1rem",
  p: 5,
  display: "flex",
  flexDirection: "column",
  fontSize: "1.8rem",
  gap: "3rem",
};


const TestEndModal = ({ open, handleClose, resultData }) => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.userData?.user);

  return (
    <Modal
      open={open}
      // onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        {open && <CelebrationAnimation />}
        <div className="modalTop1">
          <span className="modalTitle">Test Result</span>
          <span className="timeTaken">
            Time Taken: {formatedTime(resultData?.testSubmisionDuration)}
          </span>
        </div>
        <div className="modalTop2">
          {user && (
            <div className="modalUser">
              <span className="userName">{user?.fullName}</span>
              <span>{user?.email}</span>
            </div>
          )}
          <div className="modalScore">
            Score: {`${resultData?.score?.toFixed(2)}/${resultData?.totalScore?.toFixed(2)}`}
          </div>
        </div>

        <div className="modalMiddle">
          <span>Test Performance</span>
          <div className="modalMiddleChild">
            <PerformanceChart
              data={[
                ["AnswerType", "Percentage"],
                ["Unanswered", resultData?.unAttempted],
                ["InCorrect answer", resultData?.inCorrectAns],
                ["Correct answer", resultData?.correctAns],
              ]}
            />
            <div className="performanceText">
              <PerformanceCard
                signClass="right-sign"
                cardClass="correctAnswer"
                percentage={resultData?.correctAns}
                text="Correct answer"
              />
              <PerformanceCard
                signClass="cross-sign"
                cardClass="wrongAnswer"
                percentage={resultData?.inCorrectAns}
                text="InCorrect answer"
              />
              <PerformanceCard
                signClass="empty-box"
                cardClass="unanswered"
                percentage={resultData?.unAttempted}
                text="Unanswered"
              />
            </div>
          </div>
        </div>

        <div className="modalBottom">
          <button
            className="gotoDashBtn"
            onClick={() => navigate("/dashboard")}
          >
            Go To Dashboard
          </button>
          <button
            className="testReview"
            onClick={() => navigate("/testreview")}
          >
            Review
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default TestEndModal;


const MainBox = styled.div`



`

